import { useEffect, useState } from "react";
import { Title, Section, Button } from "@vshp/ui-components";
import axios from "axios";
import { Modal, Form, Input } from "antd";
import programConsultationBg from "../../../public/images/consultation.jpg";
import { API_URL } from "../../config/config";
import { SOURCE, ORGANIZATION } from "../../constants/global";
import Image from "next/image";
import { checkPhoneNumber } from "../../validators/phone-number";
import { loadingIcon, UserIcon, MailIcon, CrossIcon, PhoneIcon } from "../utils/svg";

const Consultation = () => {
  const [form] = Form.useForm();
  const { TextArea } = Input;

  const [open, setOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  let timer;

  const showModal = () => {
    setOpen(true);
  };

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleResetForm = () => {
    form.resetFields();
    setIsSuccess(false);
  };

  useEffect(() => {
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, []);

  const onFinish = (values) => {
    setConfirmLoading(true);

    const config = { ...values, source: SOURCE, org: ORGANIZATION };

    axios
      .post(`${API_URL}contact_form`, config)
      .then((response) => {
        setConfirmLoading(false);
        setIsSuccess(true);
        form.resetFields();

        timer = setTimeout(() => {
          handleCancel();
        }, 2000);
      })
      .catch((e) => {
        console.log("error loading feedback", e);
      });
  };

  return (
    <section className="page__block page__block_cover page__block_center page__block_cover_white">
      <Image className="page__block-img" src={programConsultationBg} alt="Получите консультацию у специалиста!" />
      <div className="page__block-body">
        <Title type="h2" decor={false}>
          Получите консультацию у специалиста!
        </Title>
        <Section.BodySmall>
          <div className="wysiwyg">
            <p>
              Если у вас есть вопросы по обучению, мы с удовольствием проконсультируем вас.
              <br />
              Напишите нам и мы подберем вам программу обучения, поможем с переводом из другого учебного заведения и т.д.
            </p>
          </div>

          <Button spaceTop={true} onClick={showModal}>
            Задать вопрос
          </Button>

          <Modal
            title={<h2>Задать вопрос</h2>}
            centered
            open={open}
            cancelText={isSuccess ? "Закрыть" : "Отмена"}
            okText="Отправить"
            closeIcon={<CrossIcon />}
            okButtonProps={{ className: "btn btn_primary" }}
            cancelButtonProps={{ className: "btn btn_outline" }}
            footer={
              isSuccess
                ? [
                    <Button key="close" onClick={handleCancel}>
                      Закрыть
                    </Button>,
                  ]
                : undefined
            }
            afterClose={handleResetForm}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
          >
            {isSuccess ? (
              <h2 className="text-center feedback__form-success">Ваш вопрос отправлен!</h2>
            ) : (
              <Form colon={false} onFinish={onFinish} autoComplete="off" className="form" form={form}>
                <Form.Item name="name" className="form__item" rules={[{ required: true, message: "Введите имя" }]} validateTrigger="onSubmit">
                  <Input placeholder="Ваше имя" prefix={<UserIcon />} />
                </Form.Item>
                <Form.Item
                  name="email"
                  className="form__item"
                  dependencies={["phone"]}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (value || getFieldValue("phone")) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Введите почту или телефон"));
                      },
                    }),
                    { type: "email", message: "Введите почту корректно" },
                  ]}
                  validateTrigger="onSubmit"
                >
                  <Input placeholder="Ваша почта" prefix={<MailIcon />} />
                </Form.Item>
                <Form.Item
                  name="phone"
                  dependencies={["email"]}
                  className="form__item"
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (value || getFieldValue("email")) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Введите почту или телефон"));
                      },
                    }),
                    {
                      validator: checkPhoneNumber,
                    },
                  ]}
                  validateTrigger="onSubmit"
                >
                  <Input
                    prefix={
                      <div className="ant-input-prefix-text">
                        <PhoneIcon />
                      </div>
                    }
                    placeholder="Ваша контактный номер"
                  />
                </Form.Item>

                <Form.Item name="message" className="form__item feedback__form-message" rules={[{ required: true, message: "Оставьте сообщение", whitespace: true }]} validateTrigger="onSubmit">
                  <TextArea autoSize={{ minRows: 5 }} placeholder="Оставьте сообщение" />
                </Form.Item>

                <button type="submit" style={{ display: "none" }} />
              </Form>
            )}
          </Modal>
        </Section.BodySmall>
      </div>
    </section>
  );
};

export default Consultation;
